export const defaultTextAreaValues = {
    cols: 5,
    rows: 7,
    resize: [ 'both', 'horizontal', 'vertical', 'block', 'inline', 'inherit' ]
};
